/* ═══════════════════════════════════════════════════════════════════════════
   ARTBERY — PAGE COLLECTION · script partagé
   ═══════════════════════════════════════════════════════════════════════════

   DEUX CONSOMMATEURS, comme pour artbery-collection.css :
     1. la maquette autonome  ..... maquette-collection-v7-1.html ;
     2. le thème Shopify  ......... assets/artbery-collection.js, chargé par la
        section artbery-collection-editorial.
   Une correction faite ici est donc déjà dans le composant Shopify.

   CE QU'IL CONTIENT — les deux mécaniques qui partent en Liquid :
     · la révélation au fondu (H1, intro, compteur) ;
     · la galerie qui défile.
   CE QU'IL NE CONTIENT PAS, et qui reste dans la maquette : la barre flottante
   Trier/Filtre et le panneau DEV, qui sont des outils de maquette.

   ROBUSTESSE — chaque bloc est une fonction anonyme sous try/catch et vérifie
   la présence de ses éléments avant d'agir : le script est chargé sur des pages
   où la galerie peut ne pas exister, et une erreur ici ne doit jamais empêcher
   le reste de la page de fonctionner. Le contenu est visible sans JavaScript :
   ce script ne fait que révéler et animer.
   ═══════════════════════════════════════════════════════════════════════════ */

/* ---- RÉVÉLATION AU FONDU — reprise telle quelle de Marketing/…/Tourmaline
   Rose/chapitres/_GLOBAL_JS.txt : document-wide, RÉVERSIBLE (on bascule la
   classe selon isIntersecting, pas de unobserve — un texte qui sort de l'écran
   disparaît, et réapparaît si on y revient). Seul écart avec la source : elle
   vit dans un asset Shopify global et teste document.readyState ; ici le script
   est chargé en fin de page, le DOM est prêt. ---- */
(function(){
  try{
    var reveals = document.querySelectorAll('.v5-tr-reveal');
    if(!reveals.length) return;
    if('IntersectionObserver' in window){
      var ro = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ e.target.classList.toggle('v5-tr-visible', e.isIntersecting); });
      }, { threshold: 0.2 });
      reveals.forEach(function(el){ ro.observe(el); });
    }else{
      reveals.forEach(function(el){ el.classList.add('v5-tr-visible'); });
    }
  }catch(e){}
})();

/* ---- GALERIE QUI DÉFILE — le modèle (Cartier), ce qui en est repris et ce qui
   en a été écarté sont documentés dans le bloc CSS du même nom ; ici, les
   nombres et la mécanique.

   Le mouvement EST le composant : sans JavaScript, la galerie reste une rangée
   de liens lisibles coupée au bord de l'écran — dégradée, mais pas cassée.

   DEUX MODES, choisis sur le nombre de cartes :
     · « plein » (4 cartes ou plus sur ordinateur, 2 ou plus sur mobile) —
       rangée dupliquée, boucle infinie, dérive lente au repos ;
     · « peu » (en dessous) — pas de boucle, pas de dérive : un simple
       débattement au scroll autour d'une position initiale, et des cartes
       DESSINÉES pour occuper le vide de part et d'autre.
   Le mode est réévalué à chaque redimensionnement : deux cartes, c'est « peu »
   sur ordinateur et « plein » sur mobile. Sur ordinateur, quatre cartes
   remplissent déjà l'écran (3,8 y sont visibles) : elles n'ont aucun vide à
   combler, d'où un seuil à 3.

   NOMBRE DE CARTES — lu sur l'attribut data-cartes de <html> s'il existe (c'est
   le réglage du panneau DEV de la maquette), sinon le nombre réel de cartes
   présentes dans le balisage. Côté Shopify, l'attribut n'existera pas : la
   galerie prendra simplement toutes les cartes que le Liquid aura écrites.
   ---- */
(function(){
  try{
    var gal = document.querySelector('[data-gal]');
    if(!gal) return;
    var wrapper = gal.querySelector('.gal__wrapper');
    var depart  = wrapper && wrapper.querySelector('.gal__row');
    if(!wrapper || !depart) return;

    /* ---------------- tous les nombres, ici et nulle part ailleurs ------- */
    var RATIO   = 0.14;   /* px horizontaux pour 1 px de descente. Cartier mesuré
                             à 0,44 — « beaucoup plus lent » demandé, on est trois
                             fois en dessous. */
    var LISSAGE = 0.06;   /* part du retard rattrapée à chaque image (Cartier : 0,08) */
    var DERIVE  = 16;     /* px/s de défilement au repos. N'existe pas chez Cartier :
                             vient de la demande « quand on ne scrolle pas, ça
                             défile doucement ». */
    var AMPLI   = 55;     /* mode « peu » : débattement TOTAL au scroll, réparti de
                             part et d'autre de la position initiale. */
    var SEUIL   = { ordi:3, mobile:1 };          /* au-DELÀ : mode « plein ». Donc
                             4 cartes suffisent sur ordinateur, 2 sur mobile. */
    var FROTTEMENT = 0.94;/* part de vitesse conservée à chaque 16 ms après le
                             relâché — c'est l'élan du balayage tactile. */
    var DESSINEES = 2;                           /* cartes dessinées de chaque côté */
    var PART    = { ordi:0.40, mobile:0.10 };    /* part visible de la dernière carte
                             dessinée à gauche, en position initiale */

    /* Le balisage d'origine est mis de côté carte par carte : c'est de cette
       liste qu'on reconstruit le ruban à chaque changement de mode, jamais du
       DOM courant — qui contient déjà, lui, soit une rangée dupliquée, soit des
       cartes dessinées. */
    var CARTES = [];
    [].forEach.call(depart.querySelectorAll('.gcard'), function(c){ CARTES.push(c.outerHTML); });
    if(!CARTES.length) return;

    var mobile = function(){ return window.matchMedia('(max-width:720px)').matches; };

    /* Mouvement réduit demandé par le système : on ne coupe pas le composant, on
       met sa mécanique à zéro. Le ruban reste immobile et se laisse toujours
       attraper à la main — c'est le mouvement AUTOMATIQUE qui est proscrit, pas
       le déplacement volontaire. */
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      RATIO = 0; DERIVE = 0; AMPLI = 0; LISSAGE = 1;
    }

    var nb = parseInt(document.documentElement.getAttribute('data-cartes'), 10);
    if(!(nb > 0) || nb > CARTES.length) nb = CARTES.length;

    var mode = '', signature = '', longueur = 1, x0 = 0, fige = false;
    var cible = 0, actuel = 0, derive = 0, precedent = 0;
    var drag = null, cibleAuDrag = 0, bouge = false;
    var vitesse = 0, dernierX = 0, dernierT = 0;   /* élan du balayage (px/ms) */

    /* À PARTIR DE COMBIEN DE PIXELS UN CLIC DEVIENT-IL UN GLISSÉ — et c'est la
       seule chose que ce nombre décide, mais elle est lourde : au-delà, le lien
       de la carte survolée n'est PAS suivi.

       Il valait 4 px, et c'était trop serré : une main qui appuie sur un bouton
       de souris bouge presque toujours de quelques pixels, un doigt bien
       davantage. Presque tous les clics étaient donc pris pour des glissés, et
       les cartes ne s'ouvraient pas — mesuré sur la page en aperçu : un clic
       parfaitement immobile ouvre la collection, le même clic accompagné de
       6 px de déplacement ne fait rien du tout.

       10 px est la valeur usuelle : au-dessus de la tremblote de la main, très
       en dessous d'un balayage voulu, qui dépasse la centaine de pixels. Le
       ruban, lui, suit le pointeur dès le premier pixel comme avant : ce seuil
       ne change que la lecture de l'intention, jamais le mouvement. */
    var SEUIL_GLISSE = 10;

    function cartesHtml(n){
      var s = '';
      for(var i = 0; i < n; i++) s += CARTES[i];
      return s;
    }
    function contoursHtml(n){
      var s = '';
      for(var i = 0; i < n; i++) s += '<span class="gcard gcard--ghost" aria-hidden="true"></span>';
      return s;
    }

    function construire(){
      var recale = false;
      var m = nb > (mobile() ? SEUIL.mobile : SEUIL.ordi) ? 'plein' : 'peu';
      /* Les flèches n'ont de sens que là où il reste quelque chose à faire
         venir : en mode « peu », tout est déjà à l'écran. */
      gal.classList.toggle('is-plein', m === 'plein');
      var sig = m + ':' + nb;
      if(sig !== signature){
        signature = sig; mode = m;
        var base = cartesHtml(nb);
        if(m === 'plein'){
          /* La rangée est dupliquée : quand la première sort à gauche, la
             seconde a déjà pris sa place. aria-hidden sur la copie — sans lui,
             la liste des collections serait annoncée deux fois. */
          wrapper.innerHTML = '<div class="gal__row">' + base + '</div>' +
                              '<div class="gal__row" aria-hidden="true">' + base + '</div>';
        }else{
          wrapper.innerHTML = '<div class="gal__row">' +
            contoursHtml(DESSINEES) + base + contoursHtml(DESSINEES) + '</div>';
        }
        actuel = cible = derive = 0;
        recale = true;
      }
      /* Une seule carte sur mobile : plus rien à atteindre, on rend le ruban
         inerte au doigt. Sur ordinateur en mode « peu », le glissé reste
         possible : rien n'a demandé de l'y retirer. */
      fige = (m === 'peu' && mobile());
      gal.classList.toggle('is-fige', fige);
      mesurer(recale);
    }

    /* Remesuré à chaque redimensionnement, même sans changement de mode : la
       largeur des cartes est en vw, elle suit la fenêtre.

       `recale` corrige un défaut visible sur mobile : la position était RÉÉCRITE
       à chaque appel, or sur téléphone la barre d'adresse qui se replie pendant
       qu'on descend déclenche un resize. Le ruban se rappelait donc brutalement
       à sa position initiale en plein défilement, par à-coups. On ne réécrit
       plus la position que lorsque le ruban vient d'être RECONSTRUIT ; sinon on
       met les mesures à jour et le lissage emmène le ruban vers la nouvelle
       cible. */
    function mesurer(recale){
      var row = wrapper.querySelector('.gal__row');
      if(!row) return;
      longueur = row.offsetWidth || 1;
      x0 = 0;
      if(mode === 'peu'){
        /* On cale le ruban pour ne montrer que la FIN de la dernière carte
           dessinée de gauche : 40 % sur ordinateur, 10 % sur mobile. Mesuré sur
           l'élément réel plutôt que recalculé — offsetLeft contient déjà les
           marges qui le précèdent. */
        var g = row.querySelectorAll('.gcard--ghost')[DESSINEES - 1];
        if(g) x0 = -(g.offsetLeft + g.offsetWidth * (1 - (mobile() ? PART.mobile : PART.ordi)));
        completerContours(row);
        if(recale) actuel = cible = x0;
      }
      /* La position du ruban dans le document vient peut-être de changer — une
         reconstruction, un redimensionnement ou l'arrivée de Montserrat. C'est
         le seul endroit d'où le cache peut se périmer, donc le seul où il se
         rafraîchit. */
      mesurerCadre();
      if(recale) pose(actuel);
    }

    /* Deux cartes vides de chaque côté suffisent à gauche (on n'en montre qu'une
       fraction) mais pas toujours à droite, où elles peuvent s'arrêter avant le
       bord de l'écran. Plutôt que d'augmenter la constante — ce qui ne ferait
       que déplacer le problème à la prochaine largeur d'écran — on en ajoute
       jusqu'à ce que la rangée dépasse vraiment le bord. Ajouter à la FIN ne
       décale rien : les positions des éléments précédents, donc x0, ne bougent
       pas. La marge de sécurité AMPLI/2 tient compte du débattement au scroll,
       qui peut découvrir d'autant plus de vide à droite. */
    function completerContours(row){
      var pire = x0 - AMPLI / 2, garde = 0;
      while(garde++ < 12){
        var dernier = row.lastElementChild;
        if(!dernier) return;
        if(dernier.offsetLeft + dernier.offsetWidth + pire >= gal.clientWidth) return;
        row.insertAdjacentHTML('beforeend', contoursHtml(1));
      }
    }

    /* ── LA POSITION DU RUBAN DANS LA PAGE, EN CACHE ────────────────────────
       Mesuré le 2026-08-13 par PageSpeed : ce fichier coûtait 5 649 ms de
       processeur sur mobile, 41 % de tout le JavaScript de la page, six fois
       plus que le deuxième. La cause tenait en deux gestes répétés soixante
       fois par seconde : on ÉCRIVAIT un transform, puis on RELISAIT
       `getBoundingClientRect()` — et une lecture de géométrie juste après une
       écriture de style force le navigateur à recalculer toute la mise en page
       sur-le-champ. Soixante recalculs par seconde, pour rien.

       On garde donc la position du ruban DANS LE DOCUMENT, qui ne change ni au
       défilement ni à l'animation : seuls un redimensionnement, une
       reconstruction ou l'arrivée d'une police peuvent la déplacer. La position
       à l'écran s'en déduit par une simple soustraction du défilement, qui, elle,
       ne coûte rien.

       `rect` est facultatif : l'IntersectionObserver en fournit un gratuitement
       (il l'a déjà calculé), et c'est la seule mesure qui n'a rien à payer. */
    var galHaut = 0, galHauteur = 0;

    function defilement(){
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }
    function mesurerCadre(rect){
      var r = rect || gal.getBoundingClientRect();
      galHaut = r.top + defilement();
      galHauteur = r.height;
    }

    /* Part du décalage due au scroll — la seule chose que Cartier calcule.
       `avancement` va de 0 (le rail entre par le bas de l'écran) à 1 (il en sort
       par le haut). En mode « peu », on n'en garde qu'un débattement de quelques
       dizaines de pixels autour de la position initiale. */
    function partScroll(){
      var h = window.innerHeight;
      var top = galHaut - defilement();
      var avancement = (h - top) / (h + galHauteur);
      return mode === 'peu' ? -(avancement - 0.5) * AMPLI
                            : -avancement * (h + galHauteur) * RATIO;
    }

    function pose(v){
      /* Repli sans couture : le ruban ne s'éloigne jamais de plus d'une rangée,
         il repart de zéro sans qu'on le voie. */
      if(mode === 'plein'){ v = ((v % longueur) + longueur) % longueur - longueur; }
      wrapper.style.transform = 'translate3d(' + v.toFixed(2) + 'px,0,0)';
    }

    function boucle(t){
      var dt = precedent ? Math.min(64, t - precedent) : 16;
      precedent = t;
      /* La dérive est comptée en px PAR SECONDE et non par image : la vitesse
         reste la même sur un écran à 60 Hz et sur un à 120 Hz. */
      if(mode === 'plein' && drag === null && !lance()) derive -= DERIVE * dt / 1000;
      /* L'ÉLAN après le relâché : sans lui, le ruban s'arrête net dès qu'on lève
         le doigt, ce qui rend le balayage rigide. La vitesse du geste est
         conservée puis amortie, l'amortissement exprimé par 16 ms pour rester
         identique quel que soit le rafraîchissement. */
      if(drag === null && lance()){
        derive += vitesse * dt;
        vitesse *= Math.pow(FROTTEMENT, dt / 16);
      }else if(drag === null){ vitesse = 0; }

      if(drag === null) cible = (mode === 'peu' ? x0 : derive) + partScroll();
      /* Pendant le geste et pendant l'élan, le ruban colle EXACTEMENT à la
         cible : c'est l'autre moitié de la rigidité corrigée. Le lissage de
         Cartier fait traîner le ruban de plusieurs dizaines de pixels derrière
         le doigt — juste sous la molette, insupportable sous le doigt. Il ne
         sert donc plus qu'au mouvement automatique. */
      var direct = (drag !== null) || lance();
      actuel += (cible - actuel) * (direct ? 1 : LISSAGE);
      pose(actuel);
      image = requestAnimationFrame(boucle);
    }
    function lance(){ return Math.abs(vitesse) > 0.02; }   /* px/ms — sous ce seuil, l'élan est fini */

    /* ── LA BOUCLE NE TOURNE QUE QUAND LE RUBAN EST À L'ÉCRAN ───────────────
       Second volet de la correction du 2026-08-13. La boucle se rappelait
       elle-même sans condition : elle tournait donc soixante fois par seconde
       pendant toute la vie de la page, y compris longtemps après que le ruban
       soit sorti de l'écran — et sur une page collection, il en sort au bout de
       deux gestes de défilement, la grille produits faisant toute la longueur.

       À l'arrêt, on remet `precedent` à zéro : sans ça, la première image après
       une reprise verrait un `dt` égal à tout le temps passé hors écran, et le
       ruban ferait un bond. Et on recale `actuel` sur `cible` avant de repartir,
       parce que la cible a bougé avec le défilement pendant la pause : sans ce
       recalage, le ruban rattraperait son retard en glissant sous les yeux du
       visiteur au moment précis où il apparaît. Le recalage a lieu au seuil
       d'entrée, donc tout en bord d'écran, là où il ne se voit pas. */
    var image = 0;

    function demarrer(){
      if(image) return;
      precedent = 0;
      if(drag === null){
        cible = (mode === 'peu' ? x0 : derive) + partScroll();
        actuel = cible;
        pose(actuel);
      }
      image = requestAnimationFrame(boucle);
    }
    function arreter(){
      if(!image) return;
      cancelAnimationFrame(image);
      image = 0;
    }

    /* Glissé à la main, souris ET doigt (Cartier fait de même ; ce qu'on ne
       reprend pas, c'est la capture de la molette). */
    gal.addEventListener('pointerdown', function(e){
      if(fige) return;                                               /* une seule carte sur mobile : rien à faire glisser */
      if(e.target.closest && e.target.closest('.gal-nav')) return;   /* les flèches ne sont pas une poignée */
      drag = e.clientX; cibleAuDrag = cible; bouge = false;
      vitesse = 0; dernierX = e.clientX; dernierT = performance.now();
      /* PAS DE CAPTURE DE POINTEUR ICI — c'est ce qui empêchait d'ouvrir une
         carte. Tant qu'un élément capture le pointeur, le navigateur adresse
         le clic à CET élément (.gal) et non au lien réellement sous le
         curseur : le <a> n'était donc jamais activé. On ne capture qu'au
         moment où le geste devient un vrai glissé (voir pointermove), ce qui
         laisse le clic simple suivre son chemin normal. */
    });
    gal.addEventListener('pointermove', function(e){
      if(drag === null) return;
      var dx = e.clientX - drag;
      /* LA CAPTURE DU POINTEUR SE POSE ICI, et seulement une fois le seuil
         franchi : c'est elle qui permet de continuer à faire glisser le ruban
         quand le curseur sort de la galerie en cours de geste. Posée dès
         l'appui, comme avant, elle détournait aussi le clic simple vers .gal
         et aucune carte ne s'ouvrait. Le `!bouge` la pose une seule fois. */
      if(Math.abs(dx) > SEUIL_GLISSE){
        if(!bouge){ try{ gal.setPointerCapture(e.pointerId); }catch(_){} }
        bouge = true; gal.classList.add('is-drag');
      }
      cible = cibleAuDrag + dx;
      /* Vitesse instantanée en px/ms, relevée sur les deux derniers points :
         c'est elle qui sera rendue au ruban au relâché. */
      var maintenant = performance.now(), ecart = maintenant - dernierT;
      if(ecart > 0){ vitesse = (e.clientX - dernierX) / ecart; dernierX = e.clientX; dernierT = maintenant; }
    });
    function relacher(){
      if(drag === null) return;
      /* En boucle infinie, le déplacement fait à la main est versé dans la
         dérive : le ruban repart d'où on l'a laissé au lieu de revenir en
         arrière (chez Cartier, il revient — la cible y est recalculée depuis le
         seul scroll). En mode « peu », au contraire, on ne verse rien : la
         position initiale est composée avec les cartes dessinées, elle doit se
         retrouver telle quelle — et l'élan n'y a pas lieu d'être. */
      if(mode === 'plein'){ derive = cible - partScroll(); }
      else { vitesse = 0; }
      /* Un doigt reposé sur le ruban sans bouger ne doit pas relancer un élan
         vieux de plusieurs secondes : au-delà de 90 ms sans mouvement, le geste
         est considéré comme terminé. */
      if(performance.now() - dernierT > 90) vitesse = 0;
      drag = null;
      gal.classList.remove('is-drag');
    }
    gal.addEventListener('pointerup', relacher);
    gal.addEventListener('pointercancel', relacher);
    /* Un VRAI glissé ne doit pas ouvrir le lien sous le curseur — mais un clic
       qui a simplement tremblé, si. Le partage entre les deux se fait au seuil
       défini plus haut, et nulle part ailleurs. */
    gal.addEventListener('click', function(e){ if(bouge) e.preventDefault(); }, true);

    /* --- Flèches : elles n'existent qu'au survol souris, ce code ne sert donc
       jamais au tactile. Le pas vaut une « page » moins une carte, pour garder
       un repère de continuité. On ne déplace pas le ruban nous-mêmes : on décale
       la dérive et le lissage fait glisser, ce qui donne le même mouvement lent
       que le reste du composant sans transition CSS à régler. --- */
    function pas(sens){
      var carte = wrapper.querySelector('.gcard');
      if(!carte || mode !== 'plein') return;
      var marge = parseFloat(getComputedStyle(carte).marginLeft) || 0;
      var largeur = carte.offsetWidth + marge * 2;
      var n = Math.max(1, Math.floor(gal.clientWidth / largeur) - 1);
      vitesse = 0;
      derive -= sens * n * largeur;
    }
    var flPrev = gal.querySelector('.gal-nav--prev');
    var flNext = gal.querySelector('.gal-nav--next');
    if(flPrev) flPrev.addEventListener('click', function(){ pas(-1); });
    if(flNext) flNext.addEventListener('click', function(){ pas(1); });

    /* Le focus clavier sur un lien hors champ ferait défiler le conteneur (il a
       un overflow), ce qui désynchroniserait le transform du DOM. On le remet à
       zéro : c'est le transform, et lui seul, qui positionne. */
    gal.addEventListener('scroll', function(){ gal.scrollLeft = 0; });

    construire();
    /* Montserrat arrive après le premier rendu et change la largeur des titres —
       donc celle des cartes, donc la longueur de la rangée sur laquelle repose
       la boucle. On remesure quand la police est là, et là on RECALE : c'est le
       seul moment où la position de repos change parce que le contenu a changé
       de taille sous nos pieds. */
    if(document.fonts && document.fonts.ready){
      document.fonts.ready.then(function(){ mesurer(true); });
    }

    /* Second volet de la correction de l'à-coup mobile : on ne réagit qu'aux
       changements de LARGEUR. Rien dans ce composant ne dépend de la hauteur de
       la fenêtre — or c'est exactement ce que fait varier la barre d'adresse
       d'un téléphone quand on défile, plusieurs fois par seconde. */
    var minuteur, largeurConnue = window.innerWidth;
    window.addEventListener('resize', function(){
      if(window.innerWidth === largeurConnue) return;
      largeurConnue = window.innerWidth;
      clearTimeout(minuteur); minuteur = setTimeout(construire, 150);
    });

    /* Point d'entrée du panneau DEV de la maquette, qui fait varier le nombre de
       cartes pour montrer les deux modes. Sans effet côté Shopify : rien ne
       l'appelle, le panneau n'y existe pas. */
    gal.setNombre = function(n){
      nb = Math.max(1, Math.min(CARTES.length, parseInt(n, 10) || CARTES.length));
      construire();
    };

    /* Le déclencheur. Les seuils multiples ne servent pas à réagir plus souvent
       mais à REMESURER gratuitement : chaque franchissement livre un
       `boundingClientRect` que l'observateur a déjà calculé, ce qui garde le
       cache juste même si quelque chose au-dessus du ruban a changé de hauteur
       entre-temps — une image de hero qui finit de charger, par exemple.

       Sans IntersectionObserver, on retombe sur l'ancien comportement : la
       boucle tourne en continu. C'est le cas des navigateurs d'avant 2019, et
       mieux vaut un ruban qui coûte cher qu'un ruban immobile. */
    if('IntersectionObserver' in window){
      var vigie = new IntersectionObserver(function(entrees){
        var e = entrees[entrees.length - 1];
        mesurerCadre(e.boundingClientRect);
        if(e.isIntersecting) demarrer(); else arreter();
      }, { threshold: [0, 0.01, 0.25, 0.5, 0.75, 1] });
      vigie.observe(gal);
    }else{
      mesurerCadre();
      demarrer();
    }
  }catch(e){}
})();
